import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacility = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_113_10637)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_113_10637",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_113_10637)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M2.7655 20.1961V4.49609H11.8653V8.09609H21.2345V20.1961H2.7655ZM4.06525 18.8961H10.5655V16.5961H4.06525V18.8961ZM4.06525 15.2961H10.5655V12.9961H4.06525V15.2961ZM4.06525 11.6961H10.5655V9.39609H4.06525V11.6961ZM4.06525 8.09609H10.5655V5.79609H4.06525V8.09609ZM11.8653 18.8961H19.9348V9.39609H11.8653V18.8961ZM13.8578 12.9961V11.6961H17.75V12.9961H13.8578ZM13.8578 16.5961V15.2961H17.75V16.5961H13.8578Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_113_10637",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgFacility;
